import { render, staticRenderFns } from "./DashboardCreateButton.vue?vue&type=template&id=63f09406&scoped=true"
import script from "./DashboardCreateButton.vue?vue&type=script&lang=js"
export * from "./DashboardCreateButton.vue?vue&type=script&lang=js"
import style0 from "./DashboardCreateButton.vue?vue&type=style&index=0&id=63f09406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f09406",
  null
  
)

export default component.exports